import { Component, Vue } from "vue-property-decorator";

import Header from "@/components/header/header";
import { Getter } from "vuex-class";

@Component({
  components: {
    Header,
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      if (vm.getSubscription) {
        next({ name: "subscriptionDashboard" });
      } else {
        next();
      }
    });
  },
})
export default class MissingSubscription extends Vue {
  @Getter getSubscription;
  @Getter getSpinner;

  goToLandingPage() {
    window.open("https://www.todoscomemos.com/mi-menu", "_blank");
  }
}
